// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1EIEx","name":"ConsentHeader_name__zbs2Q","birthday":"ConsentHeader_birthday__aQJss","skeleton":"ConsentHeader_skeleton__1LCi3"};